module.exports = __webpack_public_path__ + "static/og-image-a415d7f250a15d5cee3556ae1f9e4210.jpg";